import React from 'react';
interface SectionProps {
  id?: string;
  eyebrow?: string;
  title?: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'ivory' | 'cream' | 'parchment' | 'deep';
  width?: 'content' | 'narrow';
  children: React.ReactNode;
}
const toneClasses: Record<NonNullable<SectionProps['tone']>, string> = {
  ivory: 'bg-ivory text-ink',
  cream: 'bg-cream text-ink',
  parchment: 'bg-parchment text-ink',
  deep: 'bg-wine text-white'
};
export function Section({
  id,
  eyebrow,
  title,
  intro,
  tone = 'ivory',
  width = 'content',
  children
}: SectionProps) {
  const hasHeader = Boolean(eyebrow || title || intro);
  const isDeep = tone === 'deep';
  return <section id={id} className={`w-full py-14 md:py-24 ${toneClasses[tone]}`} data-id="element-175" data-mp="2nr4s3yv1ibw">
      <div className={`mx-auto w-full px-5 md:px-8 ${width === 'narrow' ? 'max-w-3xl' : 'max-w-5xl'}`} data-id="element-176" data-mp="7ndhmcas0wk6">
        {hasHeader && <header className="mx-auto max-w-3xl text-center" data-id="element-177" data-mp="104zfkovhfyn6">
            {eyebrow && <p className={`mb-4 text-xs font-bold uppercase tracking-[0.18em] ${isDeep ? 'text-gold-light' : 'text-wine'}`} data-id="element-178" data-mp="2zklgknztiyki">
                {eyebrow}
              </p>}
            {title && <h2 className="font-serif text-3xl font-semibold leading-tight md:text-5xl" data-id="element-179" data-mp="38f057h68nlga">{title}</h2>}
            {intro && <p className={`mx-auto mt-5 max-w-2xl text-lg md:text-xl ${isDeep ? 'text-white/80' : 'text-muted'}`} data-id="element-180" data-mp="3iajv9my4fpx4">
                {intro}
              </p>}
          </header>}
        <div className={hasHeader ? 'mt-10 md:mt-14' : ''} data-id="element-181" data-mp="3r9f2n2cwj620">{children}</div>
      </div>
    </section>;
}